module.exports = __webpack_public_path__ + "static/media/flex-plus-blue-horizontal.3764b359.svg";